export default __webpack_public_path__ + "static/media/undraw_Developer_activity_re_39tg.ee3107e3.svg";